import { GET_COINS_HISTORY } from '../../constants/ApiEndpoints'
import {
  SET_COINS_HISTORY,
  SET_COINS_HISTORY_LOADED,
  SET_COINS_HISTORY_LOADING
} from '../../constants/CoinsHistoryConstants'
import { requestHelper } from '../../utils/reduxActionUtils'

export const getCoinsHistory = () => {
  return async (dispatch, state) => {
    try {
      const { history } = state().coinsHistory
      dispatch(setCoinsHistoryLoading(true))

      const params = requestHelper({ pageLimit: 10, skip: history.length })
      const res = await fetch(GET_COINS_HISTORY, params)
      const data = await res.json()

      dispatch(setCoinsHistory(history.concat(data.result.coinTransactions)))
      dispatch(setCoinsHistoryLoading(false))

      if (data.result.coinTransactions.length < 10)
        dispatch(setCoinsHistoryLoaded(true))
    } catch (error) {
      console.log(error)
    }
  }
}

export const setCoinsHistoryLoading = payload => {
  return {
    type: SET_COINS_HISTORY_LOADING,
    payload
  }
}

export const setCoinsHistoryLoaded = payload => {
  return {
    type: SET_COINS_HISTORY_LOADED,
    payload
  }
}

export const setCoinsHistory = payload => {
  return {
    type: SET_COINS_HISTORY,
    payload
  }
}
